import { t } from '../../i18n.js';

export default function bookingCheckEmail({
                                              $,
                                              state,
                                              data,
                                              routes,
                                              emit,
                                              sharedState,
                                              onNext,
                                              onComplete,
                                              onSaveState
                                          }) {
    function render() {
        const $el = $(`
    <div class="booking-check-email-row text-center" data-auth-step="booking-check-email">
        <button class='login-close-button' style="display: none">&times;</button>
        <h3>${t('checkEmailSentTitle')}</h3>
        <p>${t('checkEmailSentSubTitle')}</p>
        <hr>
        <p>${t('checkEmailAfterPasswordChange')}</p>
        <button class="primary-button btn-password-changed" data-step="booking-login">${t('checkEmailBackBtn')}</button>
    </div>        `);

        return $el;
    }

    return {render};
}